import {StyleSheet, Text, View} from 'react-native';
import React, {useEffect, useRef} from 'react';
import {ZoomMtg} from '@zoom/meetingsdk'; //v1 - 3.13.2 //v2 - 5.1.2 //v3 - 6.0.0
import zoomBg from '@/Assets/Images/ZoomBg/csoc_zoom_bg.png';
// import {KJUR} from 'jsrsasign'; //    "jsrsasign": "11.1.0"
import ENV from '../../../../../environment';
import CCText from '@/Atoms/CCText';
import {FontSizes, WINDOW_WIDTH} from '@/Utils/Dimensions';
import CCColors from '@/Utils/CCColors';
import NetworkQualityMonitor from '@/Components/NetworkQualityMonitor';
import CoachDeviceWarning from '@/Components/CoachDeviceWarning';

// Full HD only for devices larger than a large tablet (> 1024px wide).
// Phones and small/regular tablets default to false — Full HD wastes
// bandwidth and processing power on screens too small to benefit from it.
const LARGE_TABLET_BREAKPOINT = 1024;
const isLargerThanLargeTablet = WINDOW_WIDTH > LARGE_TABLET_BREAKPOINT;

// Performance detection:
// 1. Check logical processors (cores). Low-end is usually <= 4.
// 2. Check RAM (if supported by browser). Low-end is usually <= 4GB.
const hardwareConcurrency = navigator.hardwareConcurrency || 4;
const deviceMemory = (navigator as any).deviceMemory || 6;
const isLowEndHardware = hardwareConcurrency <= 4 || deviceMemory <= 4;

// Host auto-camera: re-enable the camera if a host turns it off.
const HOST_AUTO_CAMERA_CHECK_INTERVAL_MS = 5 * 60 * 1000;

// 3. Check Network Quality (if supported by browser).
// Poor when effectiveType is 2g/3g OR round-trip time is > 300ms.
const HIGH_RTT_THRESHOLD_MS = 300;
const connection = (navigator as any).connection || (navigator as any).mozConnection || (navigator as any).webkitConnection;
const isSlowEffectiveType = connection && ['slow-2g', '2g', '3g'].includes(connection.effectiveType);
const isHighRtt = connection && typeof connection.rtt === 'number' && connection.rtt > HIGH_RTT_THRESHOLD_MS;
const isPoorConnection = !!(isSlowEffectiveType || isHighRtt);

const isLowEndDevice = isLowEndHardware || isPoorConnection;

console.log(`[ZoomPerformance] Cores: ${hardwareConcurrency}, RAM: ${deviceMemory}GB, connection type: ${connection?.effectiveType}, rtt: ${connection?.rtt}ms, PoorNetwork: ${isPoorConnection}, LowEndMode: ${isLowEndDevice}`);

const {ZOOM_IFRAME_BASE_EXIT_URL, ZOOM_CLIENT_ID} = ENV;
// const {ZOOM_CLIENT_ID} = ENV;

const ZoomMeeting = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const meetingEnded = urlParams.get('meetingEnded') === 'true' || false;
  const meetingId = urlParams.get('meetingId') || '';
  const pwd = urlParams.get('pwd') || '';
  const tk = urlParams.get('tk') || '';
  const signature = urlParams.get('signature') || '';
  const userName = urlParams.get('userName') || '';
  const userEmail = urlParams.get('userEmail') || '';
  const classType = urlParams.get('classType') || '';
  const callType = urlParams.get('callType') || '';
  const webinarRowId = urlParams.get('webinarRowId') || '';
  const studentId = urlParams.get('studentId') || '';
  const topic = urlParams.get('topic') || '';
  const meetingRole = urlParams.get('meetingRole') || 'student';

  const sdkKey = ZOOM_CLIENT_ID;

  // CC - Dev;
  // const sdkKey = 'vQmoHYNFQY6RzjczanVLFA';
  // const sdkSecret = 'mXJcJZaM46aPozHsaZX4T2RrnfImezd1';
  // const meetingNumber = '95689689141';
  // const passWord = '731677';
  // const meetingNumber = '98966376812';
  // const passWord = '150349';

  // local;
  // const sdkKey = 'hfDhPycTnanCyDQQkn8qw';
  // const sdkSecret = '10okVOlRMwajMMWnU6JJbSURpTSQ3P5o';
  // const meetingNumber = '81868790846';
  // const passWord = 'dpxL4f';
  // const passWord = 'd3RBAn';
  // const meetingNumber = '89096301876';

  // const role = 1;
  const zakToken = '';
  // const leaveUrl = `${ZOOM_IFRAME_BASE_EXIT_URL}/?zoomEmbed=true&meetingEnded=true`;
  // const useremail = 'support@circlechess.com';

  const zoomRootRef = useRef<HTMLDivElement>(null);

  // const generateZoomToken = () => {
  //   if (!sdkKey || !sdkSecret) {
  //     throw new Error('Missing Zoom SDK key or secret in ENV');
  //   }

  //   const iat = Math.floor(Date.now() / 1000);
  //   const exp = iat + 60 * 60; //*24;

  //   console.log('iat', iat);

  //   const header = {alg: 'HS256', typ: 'JWT'};
  //   const payload = {
  //     sdkKey,
  //     mn: meetingNumber, // meetingId, //
  //     role,
  //     iat,
  //     exp,
  //     appKey: sdkKey,
  //     tokenExp: exp,
  //   };

  //   const sHeader = JSON.stringify(header);
  //   const sPayload = JSON.stringify(payload);

  //   const Fendsignature = KJUR.jws.JWS.sign(
  //     'HS256',
  //     sHeader,
  //     sPayload,
  //     sdkSecret,
  //   );

  //   console.log('Fend Sign', Fendsignature, 'Backend', signature);
  //   // userEmail = 'support@circlechess.com';
  //   if (Fendsignature) startMeeting(Fendsignature);
  // };

  function startMeeting(signature: string) {
    if (zoomRootRef.current) {
      zoomRootRef.current.style.display = 'block';
    }
    // const ZOOM_IFRAME_BASE_EXIT_URL =
    //   window.location.origin || 'https://learn.circlechess.com';
    const leaveParams = new URLSearchParams({
      zoomEmbed: 'true',
      meetingEnded: 'true',
      classType,
      callType,
      webinarRowId,
      studentId,
      topic,
    });
    const leaveUrl = `${ZOOM_IFRAME_BASE_EXIT_URL}/?${leaveParams.toString()}`;
    ZoomMtg.init({
      debug: false,
      leaveUrl: leaveUrl,
      patchJsMedia: true,
      leaveOnPageUnload: true,
      disablePreview: false,
      defaultView: isLowEndDevice ? 'speaker' : 'gallery',
      showMeetingHeader: false, //doesnt work
      disableZoomLogo: true,
      meetingInfo: ['topic', 'host'],
      videoDrag: false,
      enableWaitingRoomPreview: true,
      enableHD: !isLowEndDevice, // Disable HD on older/slower devices
      enableFullHD: isLargerThanLargeTablet && !isLowEndDevice,
      disablePictureInPicture: true,
      success: (success: unknown) => {
        console.log(success);
        ZoomMtg.join({
          signature: signature,
          sdkKey: sdkKey,
          meetingNumber: meetingId, //meetingNumber, // meetingId, //
          passWord: pwd, //passWord, //pwd, //
          userName: userName,
          userEmail: userEmail, //useremail, //userEmail,
          tk: tk,
          zak: zakToken,
          success: (success: unknown) => {
            console.log(success);
            // ─── Virtual Background Implementation ──────────────────────────────────────
            if(meetingRole !== 'student'){
            ZoomMtg.updateVirtualBackgroundList({
              vbList: [
                {
                  id: 'csoc-zoom-bg',
                  displayName: 'CircleChess Background',
                  fileName: 'csoc_zoom_bg.png',
                  url: zoomBg,
                },
              ],
              success: () => {
                ZoomMtg.setVirtualBackground({
                  id: 'csoc-zoom-bg',
                  success: () => {
                    console.log('Virtual background set successfully');
                    // Stop automatic mirroring
                    ZoomMtg.mirrorVideo({
                      mirrored: false,
                      success: () => console.log('Mirroring disabled'),
                      error: (e: any) =>
                        console.log('Error disabling mirroring', e),
                    });
                  },
                  error: (e: any) =>
                    console.log('Error setting virtual background', e),
                });
              },
              error: (e: any) => console.log('Error updating VB list', e),
            });
          }
          },
          error: (error: unknown) => {
            console.log(error);
          },
        });
      },
      error: (error: unknown) => {
        console.log(error);
      },
    });
  }

  useEffect(() => {
    ZoomMtg.preLoadWasm();
    ZoomMtg.prepareWebSDK();
    // generateZoomToken();
    if (signature && signature !== '') {
      startMeeting(signature);
    }
    console.log('Generating Token and Starting');
    if (
      meetingEnded &&
      meetingEnded === true &&
      localStorage.getItem('meetingStarted')
    ) {
      localStorage.removeItem('meetingStarted');
      let storedData: any = null;
      try {
        storedData = JSON.parse(localStorage.getItem('ZoomUserData') || '{}');
      } catch (error) {
        storedData = {};
      }
      const resolvedClassType = classType || storedData?.classType || '';
      const resolvedCallType = callType || storedData?.callType || '';
      const resolvedWebinarRowId = webinarRowId || storedData?.webinarRowId || '';
      const resolvedStudentId = studentId || storedData?.studentId || '';
      const resolvedTopic = topic || storedData?.topic || '';
      window.parent?.postMessage(
        {
          type: 'cc_meeting_ended',
          payload: {
            classType: resolvedClassType,
            callType: resolvedCallType,
            webinarRowId: resolvedWebinarRowId,
            studentId: resolvedStudentId,
            topic: resolvedTopic,
          },
        },
        window.location.origin,
      );
    } else {
      localStorage.setItem('meetingStarted', meetingId);
    }

    // ─── Watermark Hider ────────────────────────────────────────────────────────
    const styleId = 'zoom-v5-watermark-hider';
    if (!document.getElementById(styleId)) {
      const style = document.createElement('style');
      style.id = styleId;
      style.innerHTML = `
        /* Force hide the Zoom 5.1+ undocumented SDK Version Watermark */
        .zmu-meeting-info, 
        .send-video-container__indicator-wrapper,
        span.debug-info,
        .debug-info {
          display: none !important;
          opacity: 0 !important;
          visibility: hidden !important;
          width: 0 !important;
          height: 0 !important;
          font-size: 0 !important;
          z-index: -9999 !important;
        }
        /* Also hide any absolute positioned elements in the very top left containing text */
        div[style*="position: absolute"][style*="top: 0"][style*="left: 0"] > span {
          display: none !important;
        }
      `;
      document.head.appendChild(style);
    }

    const watermarkInterval = setInterval(() => {
      const debugSpans = document.querySelectorAll(
        '.debug-info, span.debug-info',
      );
      debugSpans.forEach(el => {
        if (el instanceof HTMLElement) {
          el.style.setProperty('display', 'none', 'important');
          el.style.setProperty('opacity', '0', 'important');
        }
      });
    }, 1000);

    // ─── Auto Join ──────────────────────────────────────────────────────────────
    let hasAttemptedJoin = false;
    let autoJoinInterval: NodeJS.Timeout | null = null;

    const tryAutoJoin = () => {
      if (hasAttemptedJoin) return;

      // Zoom 5.x renders everything inside #zmmtg-root as regular DOM (no Shadow DOM)
      const root = document.getElementById('zmmtg-root');
      if (!root) return;

      const selectors = [
        'button.preview-join-button',
        '[class*="preview-join"]',
        '.join-audio-by-voip__join-btn',
        '.zm-btn-legacy.join-audio-by-voip__join-btn',
      ];

      for (const selector of selectors) {
        const btn = root.querySelector(selector) as HTMLButtonElement | null;
        if (btn && btn.offsetParent !== null) {
          console.log(`Auto Join: clicking via selector — "${selector}"`);
          btn.click();
          hasAttemptedJoin = true;
          if (autoJoinInterval) clearInterval(autoJoinInterval);
          return;
        }
      }

      // Fallback: find any visible button with join-related text
      const allButtons = root.querySelectorAll('button');
      for (const btn of Array.from(allButtons)) {
        const text = btn.textContent?.trim().toLowerCase() ?? '';
        const isVisible = btn.offsetParent !== null;
        if (
          isVisible &&
          (text === 'join' ||
            text === 'join audio' ||
            text === 'join with computer audio')
        ) {
          console.log(
            `Auto Join: clicking via text match — "${btn.textContent?.trim()}"`,
          );
          btn.click();
          hasAttemptedJoin = true;
          if (autoJoinInterval) clearInterval(autoJoinInterval);
          return;
        }
      }
    };

    // Delay polling by 15s to give Zoom SDK time to render the preview screen
    const delayTimer = setTimeout(() => {
      autoJoinInterval = setInterval(() => {
        tryAutoJoin();
        if (hasAttemptedJoin && autoJoinInterval) {
          clearInterval(autoJoinInterval);
        }
      }, 800);
    }, 15000);

    // ─── Host Auto Camera ───────────────────────────────────────────────────────
    // Find the video toggle button. When the camera is OFF the button's
    // aria-label / accessibility name reads "start my video"; when ON it reads
    // "stop my video". Clicking it while OFF turns the camera on.
    const findVideoButton = (): HTMLButtonElement | null => {
      const root = document.getElementById('zmmtg-root');
      if (!root) return null;
      const candidates = root.querySelectorAll<HTMLButtonElement>(
        'button.send-video-container__btn, button[class*="send-video-container__btn"]',
      );
      for (const btn of Array.from(candidates)) {
        if (btn.offsetParent !== null) return btn;
      }
      return null;
    };

    const isCameraOff = (btn: HTMLButtonElement): boolean => {
      const label = (
        btn.getAttribute('aria-label') ||
        btn.textContent ||
        ''
      )
        .trim()
        .toLowerCase();
      return label.includes('start my video');
    };

    const turnCameraOnIfOff = (reason: string) => {
      const btn = findVideoButton();
      if (!btn) return false;
      if (isCameraOff(btn)) {
        console.log(`Host Auto Camera: turning camera on (${reason})`);
        btn.click();
        return true;
      }
      return false;
    };

    let hostCameraInitialInterval: NodeJS.Timeout | null = null;
    let hostCameraRecurringInterval: NodeJS.Timeout | null = null;

    if (meetingRole === 'host') {
      // Try to turn the camera on shortly after joining. Poll because the
      // footer button isn't present until the meeting UI fully renders.
      let initialAttempts = 0;
      hostCameraInitialInterval = setInterval(() => {
        initialAttempts += 1;
        const clicked = turnCameraOnIfOff('initial join');
        // Stop polling after a successful click or after ~60s of trying.
        if ((clicked || initialAttempts > 75) && hostCameraInitialInterval) {
          clearInterval(hostCameraInitialInterval);
          hostCameraInitialInterval = null;
        }
      }, 800);

      // Recurring check: if the host ever turns the camera off, turn it back
      // on within HOST_AUTO_CAMERA_CHECK_INTERVAL_MS.
      hostCameraRecurringInterval = setInterval(() => {
        turnCameraOnIfOff('recurring check');
      }, HOST_AUTO_CAMERA_CHECK_INTERVAL_MS);
    }

    return () => {
      clearTimeout(delayTimer);
      clearInterval(watermarkInterval);
      if (autoJoinInterval) clearInterval(autoJoinInterval);
      if (hostCameraInitialInterval) clearInterval(hostCameraInitialInterval);
      if (hostCameraRecurringInterval) clearInterval(hostCameraRecurringInterval);
      
      // ─── Cleanup Zoom SDK ──────────────────────────────────────────────────
      // Leave the meeting to release camera/mic and clear WASM memory
      try {
        ZoomMtg.leave({
          success: () => console.log('Zoom SDK: Cleanup successful'),
          error: (e: any) => console.log('Zoom SDK: Cleanup error', e),
        });
      } catch (e) {
        console.error('Zoom SDK: Cleanup exception', e);
      }
    };
  }, []);

  return (
    <View style={styles.container}>
      {meetingEnded ? (
        <CCText color={CCColors.Primary.Dark} fontSize={FontSizes[24]}>
          The Class is over
        </CCText>
      ) : (
        <>
          <div id="zmmtg-root" ref={zoomRootRef}></div>
          <NetworkQualityMonitor />
          <CoachDeviceWarning meetingRole={meetingRole} />
        </>
      )}
      {/* <View style={styles.overlay} /> */}
    </View>
  );
};

export default ZoomMeeting;

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  // overlay: {
  //   position: 'absolute',
  //   top: 0,
  //   left: 0,
  //   width: '100%',
  //   height: 50,
  //   zIndex: 9999,
  //   backgroundColor: 'transparent',
  //   pointerEvents: 'auto',
  // },
});
